import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function HatSchool({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M21.4107 9.00006V15.7501M5.98989 12.2V16.12C5.98989 17.06 6.45989 17.95 7.24989 18.47L8.84989 19.53C10.7499 20.79 13.2249 20.79 15.1249 19.53L16.7249 18.46C17.5149 17.93 17.9849 17.04 17.9849 16.1V12.17M9.70289 4.09L3.51989 7.51999C2.22189 8.23999 2.22189 10.1 3.51989 10.82L9.68989 14.25C11.1099 15.04 12.8499 15.04 14.2799 14.25L20.4499 10.82C21.7399 10.09 21.7399 8.22999 20.4499 7.51199L14.2699 4.08199C12.8399 3.28199 11.0999 3.28199 9.66989 4.08199L9.70289 4.09Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default HatSchool;